import i18n, { InitOptions } from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const options: InitOptions = {
  debug: process.env.REACT_APP_ENV === 'development',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
};

(async () => {
  await i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init(options);
})();
